<template>
    <div class="multas">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="egresos_upload" :title="'Subir egresos'">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h1>Subir archivos con perfiles</h1>
                <input type="file" ref="file_multas" name="profiles" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                <button @click="uploadMultas()">Subir Egresos</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="egresos_modal" :title="'Agregar egreso a '">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Egresos</h3>
                <div class="add">
                    <label>Agregar Egreso</label>
                    <input type="text" v-model="egresoName">
                    <button @click="addNewEgresoType">Agregar Nuevo</button>
                </div>
                <div>
                    <table>
                        <thead>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Eliminar</th>
                        </thead>
                        <tbody>
                            <tr v-for="(egreso, index) in egresosList" :key="index">
                                <td>{{ ++index }}</td>
                                <td>{{ egreso.name }}</td>
                                <td @click=deleteEgresoType(egreso.id)><h5>X</h5></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="egresos_modal_edit" :title="'Editar egreso'">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Editar Egreso</h3>
                <toggle-button
                    v-model="editFlag"
                    class="toggle"
                    color="#82C7EB"
                    :sync="true"
                    :width="120"
                    :height="40"
                    :labels="{checked: 'PAGADA', unchecked: 'NO PAGADA'}"/>
                <div>
                    <label for="">Valor</label>
                    <input type="number" name="" id="" v-model="editValor">
                </div>
                <div>
                    <label for="">Tipo egreso</label>
                    <select name="" id="" v-model="editType">
                        <option v-for="(egreso, index) in egresosList" :key="index" :value="egreso.name">{{ egreso.name }}</option>
                    </select>
                </div>
                <div>
                    <label for="">Detalles</label>
                    <textarea type="number" name="" id="" v-model="editDetails" rows="8"></textarea>
                </div>
                <button @click="editEgreso()">Editar Egreso</button>
            </div>
        </b-modal>
        <div class="modal-list" :class="{'display': !isOpen}">
            <div>
                <h3 @click="isOpen = false">X</h3>
                <center>
                    <h3>Generar Egreso</h3>
                </center>
                <span v-if="modelSelected" @click="change"><i class="fa-solid fa-arrow-left"></i></span>
                <div v-else class="list">
                    <input type="text" v-model="searchValue" v-on:keyup="checkTrigger" @keyup.enter="onEnter">
                    <div class="model-list" v-infinite-scroll="loadMoreModels" infinite-scroll-disabled="busyModels" infinite-scroll-distance="200">
                        <div v-for="(model, index) in models" @click="selectModel(model, index)" :key="index" :class="{'select': model.select}">
                            <div>
                                <center><img :src="model.image" alt=""></center>
                                <h5 for="">{{ model.name }}</h5>
                                <label for="">{{ model.type }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="modelSelected" class="egreso">
                    <div class="model-info">
                        <h3>Información</h3>
                        <img :src="userImgselect" alt="">
                        <div>
                            <h5>{{ userNameSelect }}</h5>
                            <label for="">{{ userTypeSelect }}</label>
                        </div>
                    </div>
                    <div class="egresos-info">
                        <h3>Agregar Egreso</h3>
                        <div>
                            <label for="">Valor</label>
                            <input type="number" name="" id="" v-model="monto">
                        </div>
                        <div>
                            <label for="">Tipo egreso</label>
                            <select name="" id="" v-model="egreso_type">
                                <option v-for="(egreso, index) in egresosList" :key="index" :value="egreso.name">{{ egreso.name }}</option>
                            </select>
                        </div>
                        <div>
                            <label for="">Detalles</label>
                            <textarea type="number" name="" id="" v-model="motivo" rows="8"></textarea>
                        </div>
                        <button @click="createMulta">Agregar Egreso</button>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="container-info">
                <div>
                    <div class="table">
                        <div>
                            <button @click="$refs.egresos_upload.show()" class="left">Subir egresos</button>
                            <h3>Lista egresos</h3>
                            <center>
                                <table v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="200">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Fecha</th>
                                            <th>Modelo</th>
                                            <th>tipo</th>
                                            <th>Valor</th>
                                            <th>Estado</th>
                                            <th>Editar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(multa, index) in multasList" :key="index" :class="{'selectModel': multa.active}" v-on:click="selectMulta(index - 1)">
                                            <td>{{ ++index }}</td>
                                            <td>{{multa.created_at.split($store.state.constants.SEPARETOR)[0]}}</td>
                                            <td>{{multa.to}}</td>
                                            <td>{{multa.egreso}}</td>
                                            <td>{{priceFormat(multa.valor)}}</td>
                                            <td :class="{'pay': multa.flag, 'no-pay': !multa.flag}">{{multa.flag === 0 ? 'NO PAGADA' : 'PAGADA'}}</td>
                                            <td><button @click="showEdit(multa)">Editar</button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </center>
                        </div>
                    </div>
                    <div class="controls">
                        <div>
                            <div>
                                <button @click="isOpen = true">Agregar Egreso</button>
                                <button @click="deleteMulta">Eliminar Egreso</button>
                                <button @click="$refs.egresos_modal.show()">Tipos de egresos</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info">
                    <div>
                        <center>
                            <h3>Informe General</h3>
                            <div>
                                <div class="info-a">
                                    <label for="">Cantidad de egresos: <span>{{cantMultas}}</span></label>
                                </div>
                                <div class="info-b">
                                    <label for="">egresos totales: <span>{{sumMultas}}</span></label>
                                </div>
                                <div class="info-c">
                                    <label for="">Cantidad egresos hoy: <span>{{cantMultasHoy}}</span></label>
                                </div>
                                <div class="info-d">
                                    <label for="">Total egresos hoy: <span>{{sumMultasHoy}}</span></label>
                                </div>
                                <div class="info-e">
                                    <table>
                                        <thead>
                                            <tr>Modelos con mas egresos</tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(multa, index) in modelsBest" :key="index">
                                                <td>{{multa.modelo}}</td>
                                                <td>{{priceFormat(multa.total)}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </center>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '../../utils/ConvertPriceNumber'
import Notify from '@/utils/Notification.js'
import RockerSwitch from 'vue-rocker-switch'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
    data() {
        return {
            multasList: [],
            limit: 20,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false,
            cantMultas: 0,
            sumMultas: 0,
            cantMultasHoy: 0,
            sumMultasHoy: 0,
            modelsBest: [],
            multaIDselect: null,
            monto: null,
            motivo: null,
            egresosList: [],
            egresoName: null,
            egreso_type: null,
            models: [],
            limitModels: 20,
            offsetModels: 0,
            busyModels: false,
            listEndModels: false,
            itemFlagModels: false,
            searchValue: '',
            modelSelected: false,
            isOpen: false,
            userIdSelect: null,
            userImgselect: null,
            userNameSelect: null,
            userTypeSelect: null,
            editValor: null,
            editType: null,
            editDetails: null,
            editID: null,
            editFlag: null
        }
    },
    components: {
        RockerSwitch,
        ToggleButton
    },
    name: 'multas',
    watch: {
        searchValue: function() {
            if (this.searchValue === '') {
                this.models = []
                this.getAllModels()
            }
        }
    },
    methods: {
        uploadMultas() {
            API.uploadMultasXML(this.$refs.file_multas.files[0])
                .then((res) => {
                    this.offset = 0
                    this.busy = false
                    this.listEnd = false
                    this.itemFlag = false
                    this.multasList = []
                    this.getMultasList()
                })
        },
        editEgreso() {
            API.editEgreso(this.editID, this.editValor, this.editType, this.editDetails, this.editFlag)
                .then(() => {
                    this.offset = 0
                    this.busy = false
                    this.listEnd = false
                    this.itemFlag = false
                    this.multasList = []
                    this.getMultasList()
                    this.getCantMultas()
                    this.getSumMultas()
                    this.getCantMultasHoy()
                    this.getSumMultasHoy()
                    this.$refs.egresos_modal_edit.hide()
                    Notify('dirty', 'Se edito con exito el egreso')
                })
        },
        showEdit(egreso) {
            this.editValor = egreso.valor
            this.editType = egreso.egreso
            this.editDetails = egreso.motivo
            this.editID = egreso.id
            this.editFlag = egreso.flag
            this.$refs.egresos_modal_edit.show()
        },
        selectModel(model) {
            this.models.map(model => { model.select = false })
            model.select = true
            this.userIdSelect = model.id
            this.modelSelected = true
            this.userImgselect = model.image
            this.userNameSelect = model.name
            this.userTypeSelect = model.type
        },
        getAllModels() {
            const limit = this.searchValue === '' ? this.limitModels : 'ALL'
            const offset = this.searchValue === '' ? this.offsetModels : 0
            var searchValueinitial = ''
            if (this.searchValue !== '') {
                var stagenameSeparate = this.searchValue.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchValue
                }
            } else {
                searchValueinitial = this.searchValue
            }
            API.Store.getAllModelsStore(limit, offset, searchValueinitial)
                .then((res) => {
                    if (this.searchValue !== '') {
                        this.models = res
                    } else {
                        res.map(item => { this.models.push(item) })
                        this.offsetModels += this.limitModels
                        this.itemFlagModels = true
                    }
                })
        },
        loadMoreModels() {
            if (this.searchValue !== '') {
                return
            }
            this.busyModels = true
            if (!this.listEndModels) {
                setTimeout(() => {
                    if (this.models.length < this.offsetModels) {
                        this.listEndModels = true
                        return
                    }
                    if (this.itemFlagModels) {
                        this.getAllModels()
                        this.busyModels = false
                    } else {
                        this.loadMoreModels()
                    }
                }, 1000)
            }
        },
        searchModel() {
            this.modelSearch = false
            this.getAllModels()
        },
        onEnter () {
            this.searchModel()
        },
        checkTrigger(e) {
            if (e.keyCode === 13) {
                this.limitModels = 20
                this.offsetModels = 0
                this.models = []
                this.searchModel()
            } else if (this.searchValue.length > 0) {
                this.limitModels = 20
                this.offsetModels = 0
                this.models = []
                this.searchModel()
            }
        },
        change() {
            this.models.map(model => { model.select = false })
            this.modelSelected = !this.modelSelected
        },
        deleteEgresoType(id) {
            API.deleteEgresoType(id)
                .then((res) => {
                    this.getEgresosTypeList()
                })
        },
        addNewEgresoType() {
            API.addNewEgresoType(this.egresoName)
                .then((res) => {
                    this.egresoName = null
                    this.getEgresosTypeList()
                })
        },
        getEgresosTypeList() {
            API.getEgresosTypeList()
                .then((res) => {
                    this.egresosList = res
                })
        },
        createMulta() {
            var info = {
                who: this.$store.state.user.id,
                to: this.userIdSelect,
                valor: this.monto,
                motivo: this.motivo,
                egreso: this.egreso_type
            }
            API.createMultaByModel(info)
                .then((res) => {
                    this.offset = 0
                    this.busy = false
                    this.listEnd = false
                    this.itemFlag = false
                    this.multasList = []
                    this.getMultasList()
                    this.getCantMultas()
                    this.getSumMultas()
                    this.getCantMultasHoy()
                    this.getSumMultasHoy()
                    this.isOpen = !this.isOpen
                    Notify('dirty', 'Se ha creado la multa con exito')
                })
        },
        addMulta() {
            this.$refs.addMulta.show()
        },
        selectMulta(index) {
            this.multasList.map((multa, i) => { if (i !== index) multa.active = false })
            this.multasList[index].active = !this.multasList[index].active
            this.multaIDselect = this.multasList[index].id
        },
        deleteMulta() {
            API.deleteModelMulta(this.multaIDselect)
                .then((res) => {
                    this.offset = 0
                    this.busy = false
                    this.listEnd = false
                    this.itemFlag = false
                    this.multasList = []
                    this.getMultasList()
                    this.getCantMultas()
                    this.getSumMultas()
                    this.getCantMultasHoy()
                    this.getSumMultasHoy()
                    Notify('dirty', 'Se ha eliminado la multa con exito')
                })
        },
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.multasList.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getMultasList()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        priceFormat: function(item) {
            return Price(item)
        },
        getMultasList() {
            API.getMultasList(this.limit, this.offset)
                .then((res) => {
                    res.map(multa => { this.multasList.push(multa) })
                    this.offset += this.limit
                    this.itemFlag = true
                })
        },
        getCantMultas() {
            API.getCantMultas()
                .then((res) => {
                    this.cantMultas = res.cantidad
                })
        },
        getSumMultas() {
            API.getSumMultas()
                .then((res) => {
                    this.sumMultas = Price(res.total)
                })
        },
        getCantMultasHoy() {
            API.getCantMultasHoy()
                .then((res) => {
                    this.cantMultasHoy = res.cantidad
                })
        },
        getSumMultasHoy() {
            API.getSumMultasHoy()
                .then((res) => {
                    this.sumMultasHoy = Price(res.total)
                })
        },
        mostFinedModels() {
            API.mostFinedModels()
                .then((res) => {
                    this.modelsBest = res
                })
        }
    },
    mounted() {
        this.getMultasList()
        this.getCantMultas()
        this.getSumMultas()
        this.getCantMultasHoy()
        this.getSumMultasHoy()
        this.mostFinedModels()
        this.getEgresosTypeList()
        this.getAllModels()
    }
}
</script>

<style scoped>
    .multas {
        background-color: #cdcdcd;
        height: 90vh;
        position: relative;
    }
    .multas > .display{
        display: none;
    }
    .multas > div {
        height: 100%;
        width: 100%;
        position: relative;
    }
    .multas > div.modal-list {
        padding: 40px;
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: rgba(43, 41, 38, 0.7);
        z-index: 99999;
        border-radius: 0px;
    }
    .multas > div.modal-list > div{
        background-color: #FFF;
        height: 100%;
        width: 100%;
        padding: 20px;
        color: #000;
        position: relative;
    }
    .multas > div.modal-list > div > button {
        position: absolute;
        top: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .multas > div.modal-list > div > h3 {
        font-weight: bolder;
        position: absolute;
        right: 20px;
    }
    .multas > div.modal-list > div > span > svg {
        font-weight: bolder;
        position: absolute;
        left: 20px;
        top: 27px;
        font-size: 28px;
    }
    .multas > div.modal-list > div > h3:hover {
        color: red;
        cursor: pointer;
    }
    .multas > div.modal-list > div > span > svg:hover {
        color: red;
        cursor: pointer;
    }
    .multas > div.modal-list > div > div.list{
        padding: 20px;
        height: 100%;
    }
    .multas > div.modal-list > div > div.list > input{
        width: 100%;
        height: 50px;
        border-radius: 20px;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .multas > div.modal-list > div > div.list > div.model-list{
        padding: 20px;
        overflow: auto;
        height: 80%;
        position: relative;
    }
    .multas > div.modal-list > div > div.list > div.model-list > div{
        width: 25%;
        display: inline-block;
    }
    .multas > div.modal-list > div > div.list > div.model-list > div.select {
        background-color: #63b763;
    }
    .multas > div.modal-list > div > div.list > div.model-list > div > div{
        padding: 20px;
        width: 100%;
        text-align: center;
    }
    .multas > div.modal-list > div > div.list > div.model-list > div > div > center > img{
        width: 200px;
        height: 200px;
        object-fit: cover;
    }
    .multas > div.modal-list > div > div.egreso {
        width: 100%;
        height: 90%;
        display: flex;
    }
    .multas > div.modal-list > div > div.egreso > div.model-info {
        width: 30%;
        height: 100%;
        text-align: center;
        padding: 20px;
        position: relative;
    }
    .multas > div.modal-list > div > div.egreso > div.model-info > button{
        position: absolute;
        bottom: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .multas > div.modal-list > div > div.egreso > div.model-info > img {
        width: 250px;
        height: 250px;
        object-fit: cover;
        margin-top: 40px;
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
    }
    .multas > div.modal-list > div > div.egreso > div.model-info > div {
        position: absolute;
        bottom: 10%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .multas > div.modal-list > div > div.egreso > .egresos-info {
        padding: 40px;
        width: 100%;
        height: 100%;
        text-align: center;
    }
    .multas > div.modal-list > div > div.egreso > .egresos-info > h3{
        margin: 40px;
    }
    .multas > div.modal-list > div > div.egreso > .egresos-info > div {
        margin: 10px;
        display: grid;
        padding: 20px 100px 20px 100px;
    }
    .multas > div.modal-list > div > div.egreso > .egresos-info > div > input, .multas > div.modal-list > div > div.egreso > .egresos-info > div > select {
        height: 40px;
        border-style: solid;
        border-radius: 20px;
        text-align: center;
    }
    .multas > div.modal-list > div > div.egreso > .egresos-info > div > textarea {
        border-style: solid;
        border-radius: 20px;
    }
    .multas > div.modal-list > div > div.egreso > .egresos-info > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 50%;
        height: 40px;
        font-weight: bold;
        border-radius: 30px;
    }
    .multas > div > .container-info{
        display: flex;
        height: 100%;
        width: 100%;
        padding: 25px;
    }
    .multas > div > .container-info > div {
        height: 100%;
        width: 65%;
    }
    .multas > div > .container-info > div > div{
        width: 100%;
        height: 100%;
        border-radius: 20px;
    }
    .multas > div > .container-info > div > .table{
        height: 80%;
        width: 100%;
        border-radius: 20px;
    }
    .multas > div > .container-info > div > .controls{
        height: 20%;
        width: 100%;
        position: relative;
    }
    .multas > div > .container-info > div > .controls > div > div {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        align-items: center;
        justify-items: center;
        display: grid;
    }
    .multas > div > .container-info > div > .controls > div > div > button{
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 50%;
        height: 40px;
        font-weight: bold;
        border-radius: 30px;
    }
    .multas > div > .container-info > div > .table > div{
        padding: 20px;
        background-color:#8363b7;
        border-radius: 20px;
        height: 100%;
    }
    .multas > div > .container-info > div > .table > div > h3{
        text-align: center;
        margin-bottom: 20px;
        color: #fff;
        font-weight: bold;
    }
    .multas > div > .container-info > div > .table > div > center{
        overflow-y: auto;
        height: 85%;
    }
    .multas > div > .container-info > div > .controls > div{
        padding: 10px;
        background-color: #63b763;
        border-radius: 20px;
        height: 100%;
    }
    .multas > div > .container-info > div > .table > div > center > table > thead > tr > th{
        width: 10%;
        border-style: outset;
        height: 70px;
        color: #fff;
        text-align: center;
        font-weight: bold;
    }
    .multas > div > .container-info > div > .table > div > center > table > tbody > .selectModel {
        background-color: #63b763;
    }
    .multas > div > .container-info > div > .table > div > center > table > tbody > tr > td{
        width: 10%;
        border-style: outset;
        height: 70px;
        color: #fff;
        text-align: center;
    }
    .multas > div > .container-info > div > .table > div > center > table > tbody > tr > td > button {
        margin: auto;
        background-color: #e0b059;
        color: #fff;
        width: 200;
        height: 40px;
        font-weight: bold;
        border-radius: 30px;
    }
    .multas > div > .container-info > div > .table > div > center > table > tbody > tr > .pay{
        background-color: #63b763;
    }
    .multas > div > .container-info > div > .table > div > center > table > tbody > tr > .no-pay{
        background-color: red;
    }
    .multas > div > .container-info > .info {
        width: 35%;
        height: 100%;
        padding-left: 20px;
    }
    .multas > div > .container-info > .info > div{
        background-color: brown;
        height: 100%;
        width: 100%;
    }
    .multas > div > .container-info > .info > div > center > h3 {
        color: #fff;
        padding: 20px;
    }
    .multas > div > .container-info > .info > div > center > div {
        padding: 20px;
        color: #fff;
        font-weight: bold;
    }
    .multas > div > .container-info > .info > div > center > div > .info-a {
        padding: 20px;
        background-color: #2b2926;
        border-style: groove;
    }
    .multas > div > .container-info > .info > div > center > div > .info-a > label {
        width: 100%;
        text-align: left;
        position: relative;
    }
    .multas > div > .container-info > .info > div > center > div > .info-a > label > span {
        position: absolute;
        right: 0;
    }
    .multas > div > .container-info > .info > div > center > div > .info-b {
        padding: 20px;
        background-color: #2b2926;
        border-style: groove;
    }
    .multas > div > .container-info > .info > div > center > div > .info-b > label {
        width: 100%;
        text-align: left;
        position: relative;
    }
    .multas > div > .container-info > .info > div > center > div > .info-b > label > span {
        position: absolute;
        right: 0;
    }
    .multas > div > .container-info > .info > div > center > div > .info-c {
        padding: 20px;
        background-color: #2b2926;
        border-style: groove;
    }
    .multas > div > .container-info > .info > div > center > div > .info-c > label {
        width: 100%;
        text-align: left;
        position: relative;
    }
    .multas > div > .container-info > .info > div > center > div > .info-c > label > span {
        position: absolute;
        right: 0;
    }
    .multas > div > .container-info > .info > div > center > div > .info-d {
        padding: 20px;
        background-color: #2b2926;
        border-style: groove;
    }
    .multas > div > .container-info > .info > div > center > div > .info-d > label {
        width: 100%;
        text-align: left;
        position: relative;
    }
    .multas > div > .container-info > .info > div > center > div > .info-d > label > span {
        position: absolute;
        right: 0;
    }
    .multas > div > .container-info > .info > div > div > .info-d > label > span {
        position: absolute;
        right: 0;
    }
    .multas > div > .container-info > .info > div > center > div > .info-e {
        margin-top: 20px;
    }
    .multas > div > .container-info > .info > div > center > div > .info-e > table {
        margin-top: 75px;
        background-color: #2b2926;
        padding: 30px;
        border-style: groove;
        text-align: center;
        border-color: #fff;
        width: 100%;
    }
    .multas > div > .container-info > .info > div > center > div > .info-e > table > tbody > tr > td {
        padding-left: 30px;
        padding-right: 30px;
        padding-top: 15px;
        padding-bottom: 15px;
        border-style: groove;
    }
    .multas > .modal-list {
        z-index: 9999999999999999999999;
        background-color: rgba(88,88,88,0.9);
        width: 60%;
        height: 800px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
    }
    .multas > .modal-list > center > h3 {
        margin: 70px;
    }
    .multas > .modal-list > center > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 180px;
        height: 40px;
        font-weight: bold;
        border-radius: 30px;
    }
    .multas > .modal-list > center > .models > div > .list {
        height: 500px;
        overflow-y: auto;
    }
    .multas > .modal-list > center > .models > div > .list > div {
        background: #2b2926;
        margin: 20px;
        color: #fff;
        border-radius: 20px;
        height: 30px;
        position: relative;
        width: 90%;
    }
    .multas > .modal-list > center > .models > div > .list > div > label {
        width: 150px;
    }
    .multas > .modal-list > center > .models > div > .list > .selectModel{
        background-color: #63b763;
    }
    .multas > .modal-list > center > .models > div > .list > div > label > h5 {
        font-weight: bolder;
    }
    .multas > .modal-list > center > .models > div > .list > div > label > h5:hover {
        color: red;
        cursor: pointer;
    }
    .info-wrapper > h3 {
        color: #000;
        margin-bottom: 40px;
        margin-top: 10px;
    }
    .info-wrapper > div {
        display: contents;
        margin: 20px;
    }
    .info-wrapper > div > label {
        color: #000;
        font-weight: bold;
        text-align: center;
        margin: 20px;
    }
    .info-wrapper > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 180px;
        height: 40px;
        border-radius: 30px;
    }
    .info-wrapper > div > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 180px;
        height: 30px;
        border-radius: 30px;
    }
    .info-wrapper > div > table > thead > th {
        padding: 20px;
        text-align: center;
    }
    .info-wrapper > div > table > tbody > tr > td {
        padding: 20px;
        text-align: center;
        font-size: 22px;
    }
    .info-wrapper > div > table > tbody > tr > td > h5 {
        font-weight: bolder;
        cursor: pointer;
    }
    .info-wrapper > div > table > tbody > tr > td > h5:hover {
        color: red;
    }
    .info-wrapper > div.add {
        display: flex;
        margin: 20px;
    }
    .info-wrapper > div.add > label, .info-wrapper > div.add > input, .info-wrapper > div.add > button {
        margin: 10px;
        height: 30px;
    }
    .info-wrapper > div.add > button {
        background-color: #e0b059;
        color: #fff;
        width: 180px;
        height: 30px;
        border-radius: 30px;
    }
    .info-wrapper > div.add > label {
        font-family: 16px;
    }
    .info-wrapper > div > input, .info-wrapper > div > select, .info-wrapper > div > textarea {
        width: 300px;
        height: 40px;
        border-radius: 20px;
        text-align: center;
        margin: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Reportes/Multas.vue